/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Descriptions} from "antd";
import {DescriptionsItemType} from "antd/es/descriptions";
import {CopyOutlined} from "@ant-design/icons";
import styles from './UserInfoTab.module.scss';
import {getBoolVerificationTag} from "../UserListPanel";
import {User} from "../../../../types/User";
import {useMessageStore} from "../../../../stores/messageStore";

interface UserInfoTabProps {
	selectedItem: User | undefined;
}

const UserInfoTab = ({ selectedItem }: UserInfoTabProps) => {
	const onCopy = async (str?: string) => {
		if (!str) return;
		useMessageStore.setState({
			isShow: true,
			type: 'success',
			content: `복사 완료: ${str}`,
		});
		await navigator.clipboard.writeText(str);
	};

	const items: DescriptionsItemType[] = selectedItem ? [
		{
			key: 'phoneNum',
			label: (
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					<span>전화번호</span>
					<span>{getBoolVerificationTag(selectedItem.isVerifiedPhoneNum)}</span>
				</div>
			),
			children: (
				<div>
					<CopyOutlined
						style={{cursor: 'pointer', marginRight: 12}}
						onClick={async () => onCopy(selectedItem.phoneNum)}
					/>
					<span>{selectedItem.phoneNum}</span>
				</div>
			)
		},
		{
			key: 'email',
			label: (
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					<span>이메일</span>
					<span>{getBoolVerificationTag(selectedItem.isVerifiedEmail)}</span>
				</div>
			),
			children: (
				<div>
					<CopyOutlined
						style={{cursor: 'pointer', marginRight: 12}}
						onClick={async () => onCopy(selectedItem.email)}
					/>
					<span>{selectedItem.email}</span>
				</div>
			)
		},
		{
			key: 'id',
			label: 'ID',
			children: (
				<div>
					<CopyOutlined
						style={{ cursor: 'pointer', marginRight: 12 }}
						onClick={async () => onCopy(selectedItem.id)}
					/>
					<span>{selectedItem.id}</span>
				</div>
			),
		}
	] : [];

	return (
		<div className={styles.wrap}>
			<Descriptions
				bordered
				layout="vertical"
				column={1}
				items={items}
			/>
		</div>
	);
};

export default UserInfoTab;
